export default function textSwapper() {
  return {
    _id: false,
    type: 'droplet.textSwapper',
    mediaQueries: [],
    pageCSS: '',
    groups: [
      {
        effect: 'none',
        pause: 3000,
        duration: 500,
        center: false,
        items: ['This text can'],
      },
      {
        effect: 'fade',
        pause: 3000,
        duration: 500,
        center: false,
        items: [' fade.', ' rise.', ' zoom.'],
      },
    ],
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-swapper/droplet.schema.js